<div class="tratamiento-dialog">
  <mat-card class="tratamiento-card">
    <!-- HEADER -->
    <mat-card-header
      class="irx-sobre-color tratamiento-header"
      [style.background-color]="
        loading || !alerta ? '#607d8b' : alerta?.categoria?.color || '#607d8b'
      "
      [style.color]="
        loading || !alerta
          ? '#ffffff'
          : helper.colorDeTextoSegunColor(alerta?.categoria?.color)
      "
    >
      <mat-card-title
        [cdkDragDisabled]="loading || !dragBoundary"
        cdkDrag
        cdkDragHandle
        cdkDragRootElement=".cdk-overlay-pane"
        (cdkDragStarted)="bringToFront()"
        class="tratamiento-title"
      >
        <div class="header-main-info">
          <mat-icon class="header-icon">notification_important</mat-icon>
          <div class="header-text">
            <span class="header-title">{{ title }}</span>
            @if (loading) {
              <span class="header-subtitle">Cargando...</span>
            } @else if (alerta) {
              <span class="header-subtitle">
                {{ alerta.counter ? '#' + alerta.counter : 'Sin ID' }}
                ·
                {{ alerta.configVecino?.datosPersonales?.nombre || 'Anónimo' }}
              </span>
            }
          </div>
        </div>

        <div class="header-metadata">
          @if (!loading && alerta?.estadoActual) {
            <mat-icon
              style="cursor: default"
              class="status-icon"
              [matTooltip]="'Estado: ' + estadoActual"
            >
              account_balance_wallet
            </mat-icon>
          }
        </div>

        <button
          irxBotonIcono
          (click)="cerrar()"
          tooltip="Cerrar"
          aria-label="Cerrar diálogo"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-card-title>
    </mat-card-header>

    <!-- Loading -->
    @if (loading) {
      <div class="loading-container">
        <mat-spinner color="primary"></mat-spinner>
        <p class="loading-text">Cargando información de la alerta...</p>
      </div>
    } @else if (!alerta) {
      <mat-card-content class="tratamiento-content">
        <div class="empty-state">
          <mat-icon>error_outline</mat-icon>
          <p>No se encontró la alerta o no tenés permisos para tratarla.</p>
        </div>
      </mat-card-content>
    } @else {
      <mat-card-content class="tratamiento-content">
        <div class="content-grid">
          <!-- Fila 1: Detalles + Nota | Mapa -->
          <div class="grid-cell">
            <mat-card class="info-card detalles-card" appearance="outlined">
              <mat-card-header>
                <mat-icon mat-card-avatar>description</mat-icon>
                <mat-card-title>Detalles de la alerta</mat-card-title>
                <mat-card-subtitle>
                  {{ alerta?.estadoActual || 'Sin estado' }}
                </mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                @if (fotoVecino; as foto) {
                  <div class="foto-vecino-destacada">
                    <img
                      class="irx-clickeable"
                      role="button"
                      tabindex="0"
                      [src]="foto"
                      alt="Foto del vecino"
                      (click)="mostrarVisorFotoVecino = true"
                      (keydown.enter)="mostrarVisorFotoVecino = true"
                      title="Ver foto completa"
                    />
                    <app-image-viewer
                      [imageUrl]="foto"
                      [isVisible]="mostrarVisorFotoVecino"
                      altText="Foto del vecino"
                      (closeViewer)="mostrarVisorFotoVecino = false"
                    ></app-image-viewer>
                  </div>
                }
                <div class="info-grid">
                  <div class="info-item">
                    <mat-icon class="info-icon">label</mat-icon>
                    <span class="info-text">
                      <strong>Tipo:</strong>
                      @if (alerta?.tipo) {
                        {{ alerta?.tipo }}
                      } @else {
                        <span class="no-info">Sin tipo</span>
                      }
                    </span>
                  </div>
                  <div class="info-item">
                    <mat-icon class="info-icon">category</mat-icon>
                    <span class="info-text">
                      <strong>Categoría:</strong>
                      @if (alerta?.categoria?.nombre) {
                        {{ alerta?.categoria?.nombre }}
                      } @else {
                        <span class="no-info">Sin nombre</span>
                      }
                    </span>
                  </div>
                  <div class="info-item">
                    <mat-icon class="info-icon">priority_high</mat-icon>
                    <span class="info-text">
                      <strong>Prioridad:</strong>
                      @if (alerta?.prioridad != null) {
                        {{ alerta?.prioridad }}
                      } @else {
                        <span class="no-info">Sin prioridad</span>
                      }
                    </span>
                  </div>
                  <div class="info-item">
                    <mat-icon class="info-icon">event</mat-icon>
                    <span class="info-text">
                      <strong>Fecha:</strong>
                      @if (alerta?.fechaCreacion) {
                        {{ alerta?.fechaCreacion | date: 'dd/MM/yyyy HH:mm' }}
                      } @else {
                        <span class="no-info">Sin fecha</span>
                      }
                    </span>
                  </div>
                  <div class="info-item">
                    <mat-icon class="info-icon">person</mat-icon>
                    <span class="info-text">
                      <strong>Vecino:</strong>
                      {{ vecinoNombre }}
                    </span>
                  </div>
                  <div class="info-item">
                    <mat-icon class="info-icon">phone</mat-icon>
                    <span class="info-text">
                      <strong>Tel:</strong>
                      @if (telefono) {
                        {{ telefono }}
                      } @else {
                        <span class="no-info">Sin teléfono</span>
                      }
                    </span>
                  </div>
                  <div class="info-item">
                    <mat-icon class="info-icon">badge</mat-icon>
                    <span class="info-text">
                      <strong>DNI:</strong>
                      @if (dni) {
                        {{ dni }}
                      } @else {
                        <span class="no-info">Sin DNI</span>
                      }
                    </span>
                  </div>
                  <div class="info-item">
                    <mat-icon class="info-icon">cake</mat-icon>
                    <span class="info-text">
                      <strong>Edad:</strong>
                      @if (edad) {
                        {{ edad }}
                      } @else {
                        <span class="no-info">Sin información</span>
                      }
                    </span>
                  </div>
                  <div class="info-item">
                    <mat-icon class="info-icon">wc</mat-icon>
                    <span class="info-text">
                      <strong>Sexo:</strong>
                      @if (sexo) {
                        {{ sexo }}
                      } @else {
                        <span class="no-info">Sin información</span>
                      }
                    </span>
                  </div>
                  <div class="info-item">
                    <mat-icon class="info-icon">timer</mat-icon>
                    <span class="info-text">
                      <strong>T. Resp:</strong>
                      @if (formatTiempo(alerta?.tiempoRespuesta)) {
                        {{ formatTiempo(alerta?.tiempoRespuesta) }}
                      } @else {
                        <span class="no-info">Sin información</span>
                      }
                    </span>
                  </div>
                  <div class="info-item">
                    <mat-icon class="info-icon">timelapse</mat-icon>
                    <span class="info-text">
                      <strong>T. Resol:</strong>
                      @if (formatTiempo(alerta?.tiempoResolucion)) {
                        {{ formatTiempo(alerta?.tiempoResolucion) }}
                      } @else {
                        <span class="no-info">Sin información</span>
                      }
                    </span>
                  </div>
                  <div class="info-item">
                    <mat-icon class="info-icon">location_city</mat-icon>
                    <span class="info-text">
                      <strong>Localidad:</strong>
                      @if (alerta?.localidad?.nombre) {
                        {{ alerta?.localidad?.nombre }}
                      } @else {
                        <span class="no-info">Sin nombre</span>
                      }
                    </span>
                  </div>
                  <div class="info-item">
                    <mat-icon class="info-icon">map</mat-icon>
                    <span class="info-text">
                      <strong>Zona:</strong>
                      @if (alerta?.zona?.nombre) {
                        {{ alerta?.zona?.nombre }}
                      } @else {
                        <span class="no-info">Sin nombre</span>
                      }
                    </span>
                  </div>
                  <div class="info-item full-width">
                    <mat-icon class="info-icon">place</mat-icon>
                    <span class="info-text">
                      <strong>Dirección:</strong>
                      @if (alerta?.direccion) {
                        {{ alerta?.direccion }}
                      } @else {
                        <span class="no-info">Sin dirección</span>
                      }
                    </span>
                  </div>
                  @if (alerta?.detallesDireccion) {
                    <div class="info-item full-width">
                      <mat-icon class="info-icon">info</mat-icon>
                      <span class="info-text">
                        <strong>Detalles de la dirección:</strong>
                        {{ alerta?.detallesDireccion }}
                      </span>
                    </div>
                  }
                </div>
              </mat-card-content>
            </mat-card>

            @if (alerta?.configVecino?.nota) {
              <mat-card class="info-card" appearance="outlined">
                <mat-card-header class="data-card-header">
                  <mat-icon mat-card-avatar>note</mat-icon>
                  <mat-card-title>Nota del Vecino</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p style="white-space: pre-line; margin: 0">
                    {{ alerta.configVecino.nota }}
                  </p>
                </mat-card-content>
              </mat-card>
            }
          </div>

          <div class="grid-cell">
            @if (alertaCoords) {
              <mat-card class="info-card mapa-st-card" appearance="outlined">
                <mat-card-header class="mapa-st-header">
                  <mat-icon mat-card-avatar class="mapa-st-avatar">
                    place
                  </mat-icon>
                  <mat-card-title>Ubicación de la alerta</mat-card-title>
                  <mat-card-subtitle>
                    {{ alerta?.direccion || 'Sin dirección' }}
                  </mat-card-subtitle>
                  <mat-slide-toggle
                    class="mapa-st-toggle"
                    [checked]="showStreetView()"
                    (change)="showStreetView.set($event.checked)"
                  >
                    Street View
                  </mat-slide-toggle>
                </mat-card-header>
                <mat-card-content
                  class="mapa-st-content"
                  [class.con-streetview]="showStreetView()"
                >
                  <div class="mapa-pane">
                    <app-mapa-facil-v2
                      (mapReady)="onMapaListo($event)"
                      mapId="MapaAlertaSeguridad"
                      [showMapSelector]="false"
                      [disablePopups]="true"
                    ></app-mapa-facil-v2>
                  </div>
                  @if (showStreetView()) {
                    <div class="streetview-pane">
                      <app-street-view
                        [coordinates]="alertaCoords"
                      ></app-street-view>
                    </div>
                  }
                </mat-card-content>
              </mat-card>
            }
          </div>

          <!-- Camaras de la sirena que sono con la alerta.
               El vinculo alerta-sirena no existe por referencia en seguridad:
               se reconstruye por cercania (sirena-de-alerta.helper.ts). -->
          @if (sirenaTieneCamaras) {
            <div class="grid-cell">
              <mat-card
                class="info-card camaras-sirena-card"
                appearance="outlined"
              >
                <mat-card-header>
                  <mat-icon mat-card-avatar>videocam</mat-icon>
                  <mat-card-title>Cámaras de la sirena</mat-card-title>
                  <mat-card-subtitle>
                    {{ sirenaVinculada?.chipId || 'Sirena' }} · a
                    {{ distanciaSirenaTexto }} de la alerta
                  </mat-card-subtitle>
                  <!-- Misma discreción que el botón de descargar audio de la
                       card de Multimedia: icon-button con tooltip, en el
                       header, en vez de un FAB en el cuerpo. -->
                  <button
                    irxBotonIcono
                    class="ver-camaras-btn"
                    tooltip="Ver cámaras"
                    (click)="verCamaras()"
                  >
                    <mat-icon>videocam</mat-icon>
                  </button>
                </mat-card-header>
                <mat-card-content>
                  <div class="info-grid">
                    @if (sirenaVinculada?.direccion) {
                      <div class="info-item">
                        <mat-icon class="info-icon">place</mat-icon>
                        <span class="info-text">
                          {{ sirenaVinculada?.direccion }}
                        </span>
                      </div>
                    }
                    <div class="info-item">
                      <mat-icon class="info-icon">videocam</mat-icon>
                      <span class="info-text">
                        {{ sirenaVinculada?.idsAsignados?.length }}
                        cámara(s) vinculada(s)
                      </span>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          }

          <!-- Fila 2: Multimedia | Chat -->
          @if (hayMultimedia) {
            <div class="grid-cell fila-fija">
              <mat-card class="info-card multimedia-card" appearance="outlined">
                <mat-card-header class="data-card-header">
                  <mat-icon mat-card-avatar>perm_media</mat-icon>
                  <mat-card-title>Multimedia de la alerta</mat-card-title>
                  <mat-card-subtitle>
                    {{ detalle?.multimedia?.length || 0 }} archivo(s)
                  </mat-card-subtitle>
                  @if (audiosAlerta.length) {
                    <button
                      irxBotonIcono
                      class="descargar-audio-btn"
                      tooltip="Descargar audio completo"
                      [disabled]="descargandoAudio"
                      (click)="descargarAudioCompleto()"
                    >
                      <mat-icon>download</mat-icon>
                    </button>
                  }
                </mat-card-header>
                <mat-card-content class="scrollable-content multimedia-content">
                  @if (imagenesAlerta.length) {
                    <app-carrusel
                      [imagenes]="imagenesAlerta"
                      [enableFullscreen]="true"
                      [alturaImagen]="220"
                    ></app-carrusel>
                  }
                  @if (audiosAlerta.length) {
                    <div class="audios-lista">
                      <span class="audios-titulo">
                        Audio ({{ audiosAlerta.length }} fragmento(s))
                      </span>
                      @for (m of audiosAlerta; track m._id) {
                        <div class="audio-item">
                          <span class="audio-fecha">
                            @if (m.fecha) {
                              {{ m.fecha | date: 'dd/MM/yyyy HH:mm:ss' }}
                            } @else {
                              <span class="no-info">Sin fecha</span>
                            }
                          </span>
                          <audio
                            [src]="m.url"
                            controls
                            preload="metadata"
                          ></audio>
                        </div>
                      }
                    </div>
                  }
                  @for (m of mediaOtrosAlerta; track m._id) {
                    @if (m.mime?.startsWith('video/')) {
                      <video
                        class="alerta-media"
                        [src]="m.url"
                        controls
                        preload="metadata"
                      ></video>
                    } @else {
                      <a
                        class="irx-enlace alerta-media-link"
                        [href]="m.url"
                        target="_blank"
                        rel="noopener"
                      >
                        <mat-icon>attach_file</mat-icon>
                        <span>{{ m.tipo || 'Archivo' }}</span>
                      </a>
                    }
                  }
                </mat-card-content>
              </mat-card>
            </div>
          }

          <div class="grid-cell fila-fija" [class.full-width]="!hayMultimedia">
            <mat-card class="data-card mensajes-card" appearance="outlined">
              <mat-card-header class="data-card-header">
                <mat-icon mat-card-avatar>forum</mat-icon>
                <mat-card-title>Mensajes</mat-card-title>
                <mat-card-subtitle>
                  {{ alertaMensajes.length }} mensaje(s)
                </mat-card-subtitle>
              </mat-card-header>
              <mat-card-content class="mensajes-content-wrapper">
                <div class="scrollable-content mensajes-list">
                  @if (alertaMensajes.length) {
                    @for (m of alertaMensajes; track m.id || $index) {
                      <div class="list-item mensaje-item" [class.even]="$even">
                        <div class="mensaje-header">
                          <div class="mensaje-author">
                            <mat-icon class="list-item-icon">person</mat-icon>
                            <strong>{{ m.remitente || 'Sistema' }}</strong>
                          </div>
                          <span class="mensaje-timestamp">
                            {{
                              m.fecha
                                ? (m.fecha | date: 'dd/MM/yyyy HH:mm')
                                : ''
                            }}
                          </span>
                        </div>
                        <p class="mensaje-body">{{ m.mensaje }}</p>
                      </div>
                      @if (!$last) {
                        <mat-divider class="item-divider"></mat-divider>
                      }
                    }
                  } @else {
                    <div class="empty-state">
                      <mat-icon>forum</mat-icon>
                      <p>Sin mensajes registrados</p>
                    </div>
                  }
                </div>

                <div class="mensaje-editor">
                  <mat-form-field class="mensaje-input no-hint">
                    <mat-label>Escribir mensaje</mat-label>
                    <input
                      matInput
                      [formControl]="mensajeForm"
                      maxlength="300"
                      (keyup.enter)="enviarMensaje()"
                    />
                  </mat-form-field>

                  <button
                    irxBotonIcono="borde"
                    tono="primario"
                    type="button"
                    tooltip="Enviar"
                    [disabled]="enviandoMensaje || !mensajeForm.value?.trim()"
                    (click)="enviarMensaje()"
                  >
                    <mat-icon>send</mat-icon>
                  </button>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>

        <mat-card class="data-card historial-card" appearance="outlined">
          <mat-card-header class="data-card-header">
            <mat-icon mat-card-avatar>history</mat-icon>
            <mat-card-title>Historial de Estados</mat-card-title>
            <mat-card-subtitle>
              {{ detalle?.estados?.length || 0 }} estado(s)
            </mat-card-subtitle>
          </mat-card-header>
          <mat-card-content class="scrollable-content estados-content">
            @if (detalle?.estados?.length) {
              @for (estado of estadosHistorial; track estado._id) {
                <div class="list-item estado-item" [class.even]="$even">
                  <div class="estado-status-row">
                    <mat-chip class="estado-chip">
                      {{ estado.estado }}
                    </mat-chip>
                    <span class="estado-timestamp">
                      {{
                        estado.fecha
                          ? (estado.fecha | date: 'dd/MM/yyyy HH:mm')
                          : ''
                      }}
                    </span>
                  </div>
                  @if (estado.notaPredefinida) {
                    <div class="estado-nota">
                      <mat-icon class="note-icon">comment</mat-icon>
                      <span>{{ estado.notaPredefinida }}</span>
                    </div>
                  }
                  @if (estado.nota) {
                    <div class="estado-nota">
                      <mat-icon class="note-icon">comment</mat-icon>
                      <span>{{ estado.nota }}</span>
                    </div>
                  }
                  @if (estado.notaInterna) {
                    <div class="estado-nota interna">
                      <mat-icon class="note-icon">lock</mat-icon>
                      <span>
                        <strong>Interna:</strong>
                        {{ estado.notaInterna }}
                      </span>
                    </div>
                  }
                  @if (urlsDeEstado(estado).length) {
                    <div class="estado-multimedia">
                      <app-carrusel
                        [imagenes]="urlsDeEstado(estado)"
                        [enableFullscreen]="true"
                      ></app-carrusel>
                    </div>
                  }
                </div>
                @if (!$last) {
                  <mat-divider class="item-divider"></mat-divider>
                }
              }
            } @else {
              <div class="empty-state">
                <mat-icon>history</mat-icon>
                <p>Sin historial de estados</p>
              </div>
            }
          </mat-card-content>
        </mat-card>
      </mat-card-content>

      <!-- Acciones -->
      <mat-dialog-actions class="tratamiento-actions">
        @if (!tratamientoIniciado && !esFinalizada) {
          <div class="actions-container">
            <app-button
              matType="mat-fab extended"
              color="primary"
              text="Iniciar tratamiento"
              icon="troubleshoot"
              [disabled]="actualizando"
              (click)="iniciarTratamiento()"
            ></app-button>
          </div>
        }

        @if (tratamientoIniciado && !esFinalizada) {
          <div class="actions-container tratando">
            <div class="actions-group primary-actions">
              <app-button
                matType="mat-fab extended"
                color="primary"
                text="Agregar estado"
                icon="edit_note"
                [disabled]="actualizando"
                (click)="abrirAgregarEstado()"
              ></app-button>
              <app-button
                matType="mat-fab extended"
                color="primary"
                text="Liberar"
                icon="lock_open"
                [disabled]="actualizando"
                (click)="liberar()"
              ></app-button>

              @if (puedeDerivar) {
                <app-button
                  matType="mat-fab extended"
                  color="primary"
                  text="Derivar"
                  icon="swap_horiz"
                  [disabled]="actualizando"
                  (click)="abrirDerivar()"
                ></app-button>
              }
            </div>

            <div class="actions-group secondary-actions">
              @if (puedeDevolver) {
                <app-button
                  matType="mat-fab extended"
                  color="warn"
                  text="Devolver"
                  icon="undo"
                  [disabled]="actualizando"
                  (click)="devolver()"
                ></app-button>
              }
            </div>
          </div>
        }

        @if (esFinalizada) {
          <div class="actions-container estado-final">
            <mat-icon class="estado-icon">check_circle</mat-icon>
            <h3 class="estado-mensaje">Alerta finalizada</h3>
          </div>
        }
      </mat-dialog-actions>
    }
  </mat-card>
</div>
